/**
 * Copyright 2021 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import root from 'window-or-global';
import { PersistentStorage } from './PersistentStorage';
import type { Storage } from './PersistentStorage';

export type LocalStorageKey =
  | 'azCartOrderId'
  | 'azCheckoutSubscriptions'
  | 'disableProactiveChatExpiry'
  | 'email'
  | 'forgotPasswordFlowCompleted'
  | 'fulfillmentOptionsGroupList'
  | 'hideSmartBanner'
  | 'interactionLocation'
  | 'loggedInFrom'
  | 'loyaltyBenefitEarned'
  | 'rememberMeChecked'
  | 'rewardsAccountNo'
  | 'rewardsIdEnteredForCommit'
  | 'rewardsLinkingId'
  | 'shouldDisplayLoginMsgOnReload'
  | 'username'
  | 'vehicles'
  | 'trackedOrderEmail'
  | 'serviceHistoryItem'
  | 'ymmeActionSource'
  | 'recentSearches'
  | 'reviewSubmissionId'
  | 'reviewFeedback'
  | 'delaySignInSnackBar'
  | 'displayEmailOptInAlert'
  | 'google.parameters.gateway'
  | 'google.parameters.gatewayMerchantId'
  | 'google.merchantInfo.merchantId'
  | 'google.merchantInfo.merchantName'
  | 'google.environment'
  | 'google.parameters.allowedAuthMethods'
  | 'savedForLaterItem'
  | 'sflLoginNotify'
  | 'canShowToastNotification'
  | 'hideModal'
  | 'originalFulfillmentIdsSelectedInCart'
  | 'loginInteractionMethod';

export const localStorage: Readonly<Storage<LocalStorageKey>> =
  new PersistentStorage<LocalStorageKey>(root.localStorage);
